import { GameCategory } from '../enums';

export const categoriesSportsLeaguesConfig: {
	categories: Record<string, { name: string; sport: string; league: string }>;
} = {
	categories: {
		[GameCategory.NBA]: {
			name: 'NBA',
			sport: 'basketball',
			league: 'nba',
		},
		[GameCategory.NFL]: {
			name: 'NFL',
			sport: 'football',
			league: 'nfl',
		},
		[GameCategory.MLB]: {
			name: 'MLB',
			sport: 'baseball',
			league: 'mlb',
		},
		[GameCategory.EPL]: {
			name: 'England - Premier League',
			sport: 'soccer',
			league: 'england_-_premier_league',
		},
		[GameCategory.UCL]: {
			name: 'UEFA - Champions League',
			sport: 'soccer',
			league: 'uefa_-_champions_league',
		},
		[GameCategory.FIFA]: {
			name: 'FIFA - World Cup',
			sport: 'soccer',
			league: 'fifa_-_world_cup',
		},
		[GameCategory.NCAAB]: {
			name: 'NCAAB',
			sport: 'basketball',
			league: 'ncaab',
		},
		[GameCategory.NHL]: {
			name: 'NHL',
			sport: 'hockey',
			league: 'nhl',
		},
		[GameCategory.PGA]: {
			name: 'PGA',
			sport: 'golf',
			league: 'pga',
		},
		[GameCategory.ATP]: {
			name: 'ATP',
			sport: 'tennis',
			league: 'atp',
		},
		[GameCategory.WTA]: {
			name: 'WTA',
			sport: 'tennis',
			league: 'wta',
		},
		// TENNIS is a meta-category that unions ATP + WTA fixtures. The `league`
		// value is a sentinel that intentionally does NOT match any real OpticOdds
		// league id — the fetcher short-circuits TENNIS before hitting `league`,
		// and the reverse-lookup in getDataByGameId (fixture → category) will
		// never match TENNIS because OpticOdds fixture leagues are 'atp'/'wta',
		// not 'tennis'. That's the intended behavior: match-level category
		// resolution stays on ATP/WTA, event-level category resolution uses TENNIS.
		[GameCategory.TENNIS]: {
			name: 'Tennis',
			sport: 'tennis',
			league: 'tennis',
		},
		[GameCategory.NCAAF]: {
			name: 'NCAAF',
			sport: 'football',
			league: 'ncaaf',
		},
	},
};
